<template>
  <div class="intelligentAssistanceContainer">
    <div class="chartAIMessagesContianer">
      <GeminiScrollbar :autoshow="true">
        <div style="padding: 0 10px">
          <template v-if="chartAIMessages && chartAIMessages.length > 0">
            <div :key="idx+'aiItems'" class="aiItems" v-for="(item,idx) in chartAIMessages">
              <div class="aiItem">
                <div :key="idx+'-chartAIRightMessages'" class="rightMessage">
                  <div class="messageContent">{{item.originalContent}}</div>

                  <div class="lawyerIcon"></div>
                </div>
              </div>
              <div class="aiItem">
                <div :key="idx+'-chartAILeftMessages'" class="leftMessage">
                  <div class="legalRobotIcon"></div>
                  <div class="messageContent">
                    <template v-if="item.type == 'new'">
                      <Spin></Spin>
                    </template>
                    <template v-else-if="item.success && item.ansId">
                      <printer
                        :speed="0.02"
                        :value="item.result"
                        ref="printer"
                        v-if="item.printer && idx == chartAIMessages.length -1"
                      ></printer>
                      <div style="white-space: pre-wrap;" v-else v-html="item.result"></div>
                      <div class="messageContentInfo">
                        <div class="tips">{{item.serviceCode}}</div>
                        <div class="aiTools">
                          <template v-if="item.correctStatus">
                            <Icon
                              :class="'toolAIIcon effic '+ (item.correctStatus == 'accept'?'active':'')"
                              type="md-thumbs-up"
                            />
                            <Icon
                              :class="'toolAIIcon effic '+ (item.correctStatus == 'unAdopt'?'active':'')"
                              type="md-thumbs-down"
                            />
                          </template>
                          <template v-else>
                            <Icon
                              :class="'toolAIIcon '+ (item.correctStatus == 'accept'?'active':'')"
                              @click="() => {accepted(item, 'accept')}"
                              type="md-thumbs-up"
                            />
                            <Icon
                              :class="'toolAIIcon '+ (item.correctStatus == 'unAdopt'?'active':'')"
                              @click="() => {unAdopt(item, 'unAdopt')}"
                              type="md-thumbs-down"
                            />
                          </template>
                          <Icon
                            @click="()=>{copy(item.result)}"
                            class="toolAIIcon"
                            type="ios-copy"
                          />
                        </div>
                      </div>
                    </template>
                    <span style="color: #ff3300" v-else>{{item.result || '发送失败！'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="aiItems" v-else>
            <div class="aiItem">
              <div class="leftMessage">
                <div class="legalRobotIcon"></div>
                <div
                  class="messageContent"
                >{{prompt?.welcomeTip?prompt.welcomeTip:'你好，我是人工智能语言模型，请在输入您想问的问题！'}}</div>
              </div>
            </div>
          </div>
        </div>
        <a href="#scrollAIToMe" ref="scrollAIToMe"></a>
      </GeminiScrollbar>
    </div>
    <div class="sendContainer">
      <div class="baseBtn">
        <div class="changeBtn">
          连续性对话
          <i-switch size="small" v-model="isContinuity"></i-switch>
        </div>
        <div class="changeBtn">
          流式返回
          <i-switch size="small" v-model="isStream"></i-switch>
        </div>
      </div>
      <div class="inputContainer">
        <Input
          :autosize="{maxRows: 4, minRows: 4}"
          :disabled="disabledSend"
          :placeholder="disabledSend? '正在努力回答中，请勿同时提问~': '请输入您想问的内容'"
          @on-enter="sendAiMessage"
          @on-focus="focusInput"
          class="selfInput"
          maxlength="5000"
          show-word-limit
          type="textarea"
          v-model.trim="aiMessage"
        />
        <Button
          :class="aiMessage == undefined || aiMessage == '' || aiMessage.trim() == '' ?'sendBtn':'sendBtn active'"
          :disabled="aiMessage == undefined || aiMessage == '' || aiMessage.trim() == '' || disabledSend"
          @click="sendAiMessage"
          type="primary"
        ></Button>
      </div>
    </div>

    <Modal @on-cancel="cancelPromp" title="引用模板变量录入" v-model="showPromp" width="60vw">
      <div class="mb1">{{this.prompt?.promptContent}}</div>
      <Form :label-width="120" :model="variablesForm" ref="variablesForm">
        <template v-for="variable of prompt.variables">
          <FormItem :key="variable" :label="variable" :prop="variable">
            <Input
              :autosize="{minRows: 3, maxRows: 6}"
              show-word-limit
              type="textarea"
              v-model="variablesForm[variable]"
            ></Input>
          </FormItem>
        </template>
      </Form>
      <template slot="footer">
        <Button @click="cancelPromp" type="default">取消</Button>
        <Button @click="submitPromp" type="primary">确定</Button>
      </template>
    </Modal>

    <Modal @on-cancel="unDoptCancel" title="进一步反馈" v-model="showUnAdopt" width="500px">
      <div class="content" style="max-height: 60vh; overflow-y:auto">
        <Form :inline="false" :model="unAdoptForm" ref="unAdoptForm">
          <FormItem
            :rules="[{required: true,  message: '请输入理想回答', trigger: 'blur'}]"
            label="您认为更理想的回答是什么?"
            prop="remark"
          >
            <Input
              :autosize="{minRows: 3,maxRows: 5}"
              maxlength="500"
              placeholder="请输入理想回答"
              show-word-limit
              type="textarea"
              v-model.trim="unAdoptForm.remark"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <Button @click="unDoptCancel" type="default">取消</Button>
        <Button @click="submitUnDopt" type="error">提交</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'aiChart',
  props: {
    mode: {
      required: false,
      default: 'TEST',
    },
    chartId: {
      required: true
    },
    prompt: {
      required: false,
      default: function () {
        return {}
      }
    },
    configId: {
      required: false,
      default: null
    }
  },
  watch: {
    chartId: {
      immediate: true,
      handler: function (val) {
        if (val) this.getAIChartMessages()
      }
    }
  },
  data () {
    return {
      showPromp: false,
      disabledSend: false,
      aiMessage: '',
      isContinuity: false,
      isStream: false,
      chartAIMessages: [],
      variablesForm: {

      },
      unAdoptMessagae: {},
      unAdoptForm: {
        remark: ''
      },
      showUnAdopt: false,
    }
  },
  computed: {
    aiPath: function () {
      return this.$store.getters['systemSupport/systemSupport']?.AI || process.env.VUE_APP_API_ROOT
    },
  },
  methods: {
    unAdopt: function (message, status) {
      this.unAdoptMessagae = message
      this.showUnAdopt = true
    },
    unDoptCancel: function () {
      this.unAdoptMessagae = null
      this.unAdoptForm = {}
      this.$refs.unAdoptForm.resetFields()
      this.showUnAdopt = false
    },
    submitUnDopt: function () {
      let that = this
      this.$refs.unAdoptForm.validate(valid => {
        if (valid) {
          that.accepted(that.unAdoptMessagae, 'unAdopt')
        } else {
          return false
        }
      })
    },
    accepted: function (message, status) {
      console.log('accepted', message)
      let that = this
      let params = {
        chartId: this.chartId,
        messageId: message.id,
        correctStatus: status
      }
      if (status == 'unAdopt') {
        params.remark = that.unAdoptForm.remark
      }
      this.$axios.post(this.$apis.aiApi.aiTools.correctMessage, params, {
        baseURL: this.aiPath
      }).then(res => {
        if (res.success) {
          message.correctStatus = status
          // this.$set(message, 'correctStatus', status)
          that.$Message.success('感谢您的反馈！')
          if (status == 'unAdopt') {
            this.unDoptCancel()
          }
        } else {
          that.$Message.error({
            content: res.message,
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('accepted error', err)
        that.$Message.error({
          content: '操作失败',
          duration: 3
        })
      })
    },
    copy: function (message) {
      let that = this
      this.$copyText(message).then(e => {
        this.$Message.success("内容已复制！")
      }, e => {
        this.$Message.error("内容复制失败！")
      })
    },
    getAIChartMessages: function () {
      let that = this
      that.chartAIMessages = []
      let params = new this.$URLSearchParams()
      params.append('chartId', this.chartId)
      this.$axios.post(that.$apis.aiApi.aiTools.getToolUseLogs, params, { baseURL: this.aiPath }).then(res => {
        if (res.success) {
          that.chartAIMessages = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取工具使用历史记录失败！')
      }).finally(() => {
        that.scrollToDom()
      })
    },
    focusInput: function (e) {
      console.log('this.prompt', this.prompt)
      if (this.aiMessage.trim() == '' && this.prompt?.hasVariables) {
        if (process.env.NODE_ENV != 'development') {
          e.target.blur()
        }
        this.showPromp = true
      }
    },
    cancelPromp: function () {
      this.variablesForm = {}
      this.showPromp = false
    },
    submitPromp: function () {
      let orgContent = this.prompt?.promptContent
      Object.keys(this.variablesForm).forEach(key => {
        orgContent = orgContent.replace("${#" + key + "}", this.variablesForm[key])
      })
      this.aiMessage = orgContent
      this.showPromp = false
    },
    sendAiMessage: function () {
      console.log('sendAiMessage', this.aiMessage)
      let that = this
      this.disabledSend = true
      if (this.aiMessage) {
        let params = {
          chartId: this.chartId,
          chartMessage: this.aiMessage,
          isContinuity: this.isContinuity,
          isStream: this.isStream
        }
        if (this.configId) params.configId = this.configId
        if (this.prompt) params.promptId = this.prompt?.id
        if (this.prompt?.hasVariables > 0) {
          params.params = this.variablesForm
        }
        let messageObj = { type: 'new', originalContent: this.aiMessage }
        this.chartAIMessages.push(messageObj)
        this.scrollToDom()
        this.$axios.post(that.$apis.aiApi.aiTools.sendAIMessage, params, { baseURL: this.aiPath }).then(res => {
          if (res.success) {
            let result = res.result || {}
            let chartId = result.chartId
            if (this.chartId == chartId) {
              let messages = result.list || []
              if (messages.length > 0 && chartId == that.currentGroupId) {
                messages[messages.length - 1].printer = true
              }
              that.chartAIMessages = messages
            }
          } else {
            messageObj.type = ''
            messageObj.success = false
            that.$Message.error({
              content: res.message,
              duration: 3
            })
            that.chartAIMessages[that.chartAIMessages.length - 1] = messageObj
          }
          // if (res.success) {
          //   let message = res.result || {}
          //   message.printer = true
          //   that.chartAIMessages[that.chartAIMessages.length - 1] = message
          // } else {
          //   that.$Message.error(res.message)
          //   let data = that.chartAIMessages[that.chartAIMessages.length - 1]
          //   data.success = false
          //   data.type = 'error'
          //   that.chartAIMessages[that.chartAIMessages.length - 1] = data
          // }
        }).catch(function (err) {
          console.log('sendAiMessage error', err)
          that.$Message.error('操作失败！')
          messageObj.type = ''
          messageObj.success = false
          that.chartAIMessages[that.chartAIMessages.length - 1] = messageObj
        }).finally(() => {
          that.disabledSend = false
          that.scrollToDom()
        })
        that.aiMessage = ''
      } else {
        this.disabledSend = false
      }
    },
    scrollToDom () {
      this.$nextTick(() => { // 等待 DOM 渲染完成
        let scrollAIToMe = this.$refs.scrollAIToMe
        if (scrollAIToMe) { // 如果元素存在，则滚动到目标位置
          scrollAIToMe.scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.intelligentAssistanceContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e8eaec;
  background-image: url(data:image/svg+xml;base64,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);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  .chartAIMessagesContianer {
    flex-grow: 1;
    overflow-x: hidden;
    overflow-y: hidden;
    padding: 0 0 10px 0;

    .legalRobotIcon {
      background-image: url('@/assets/static/images/im/legalRobot.png');
      background-position: center;
      background-size: 100% 100%;
      width: 1.8rem;
      height: 1.8rem;
      display: block;
      min-width: 1.8rem;
      margin-right: 0.6rem;
    }

    .lawyerIcon {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADigAwAEAAAAAQAAADgAAAAA39rQ8gAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAD+JJREFUaAWVmkusXlUVx/f5+t3S0pYWyqsPtFjQQjBE8BGMI4c2oVESjEknxujQhBETDZI4NxEGDkiYkDg0bWhijFFJHCg+QBMIhhZQSwXkJS3Qx73f8f/7r7XOObdc+tj3nrPXXs//Wmufx/fd27ULjD+82O8+c64d6Fvbv2j93q7vdvZdv3mx6FunH357CRm9CLiiLJNKDvH7TtyUQku3sy36jL6N+snBPpQkjTj23nWn+kV/QvGP9bPuyPp5O/S1O7vjYfXRc0VYJfn9C/3O5bZ4eLGYfbv1i3VkYrw6AdTrZBg2WRoMcoYALwZ8aRFJVkGsFcphAY2PtIXJamEDpaMFPj1CLYrbdSuyeXzdfPbQgbu6E6kxTKiuGk+90N+raj6hKm0Z4itI1F+uMiBG7toUGLSOTmgA5i6LFSABnHzJsa2urQIfLtIPtskQUod2vKADi+QuRXeyW9cdvO8L3WE4NVYl+Jvn+u9rB/1EpZqhAEScGPAEjZInC/uIIFPa2AJMRjGwtWhipCtm65HIpFO+HIgluYuWxanyiT3G6jqpdA98857upxnOqZtWcvfK7y96JUdCDohkQEAM3EXSA3sCrOW1ZoepVy5cEBlNAeGjhmnqZJ0oGDLXMpWKDh9lXLsFJdEyWdfNvn7/PdFJe+KaO73cvyAHWyJGbkmiVsWCVHwlqB+2G90jjGm4XshD8sNcQUGWw5RONMVs24jWgsIyiq7dETYRi2gutXDECDTeaWCytJ3ctHG2j2vSW/H0cntYYLaw9dgGwA/wAQ6gOAYQNAd6tS7aa/sAZIRfWSlgo23Yhw6uWdt/2hLfvjzLnpjGdL4PZGBMezDJUNOW9z9YPGzub//W7z7b9a/IdF3d+SIZXOKYU3TNpBnSULXtTEz0AMQomwAdgIqJyrTS6LtL3iVe4BiALHREoT2znuAYZfhAPyzCTCj6ttLWz/bMz3V6zvXNjwKU6AbSMIrECgTM4JdeOierHK48SrXdRI93U2DhM+yD1jq7bdB0QPLSi3jyQUErOEUgEDHEQx8LcLvQxOzauv5MOzBf7vv9XSphbzC2wzBM4Y+OIincGZdkFhdIbElC64wvTWzkDUXA8eNuWJI0Qg3xwUoy1jczdkuQorXtiU+k2nVugnmcUr9b2T+Xzt66ceCQ4PnrGfXgB+CokH1EFYdQaGoosYTatmxs7catXbtmc9c2LHVtriv+zHJrp0639vq7rb36jvZR6hOD4rpL0BTCTCqWyWbFYLtQ2e3auuYbROjL397uyWcWJ+VgMzb2x5w0uvjkWjOhaQwaeuhE9QIQwDYs9e323V271vdk5GmO48k4p3eQF//Tt5feiC2IH/cmkXqqRGWX7KGAuDIPv8Y5wAy+Xuvm2subUXRnIFAEkEjsFgIRq3KGZAxmWtqV5PZNrd25Z9aWdFVblkkVuODGGR0KsU02z7wcVU91KeRWTmDwjUmEdcyouIFn4OMePTVuPjRHjOiWBZJHirXbMRieTw4KABxl1aW/9crW7rpZG0OmayWE+lpj59VRtD+/FDFCJxIGBlvX3SWg1tUAghQm24AxCS47oWgzgMQRFyw+SGqYMSodBwr5yAv7ruvb5/ZEco5xmacdSnLPdfg+73D8sbsj3ohrrKkzYMobGLIZDrkTsag7F1VBOWYRSeO8dKho0GF383Vce5eelVytSgbLz+zQvV03Iu7AEWssLrGMKQ2DjsSh/cCXDmLrign+6CBMtJykJs0EiJkEEgyzqlNJWi4tivOJa2ObYbXWsLsUTOlBV0x9tmu7r4nd47cTx2txp6UrWsNfIRFk4JQDDjBxN7Wd+eChg+JHApmU1zioigVdiQ2O0JMhDrdu6NfsnlQGACJX0aw9SimXO7YFHndBsrr2rKaT45OAaL8GwgNHbkvcsK7XTt1kqAMGYiLVCU7AYVJVkhMdlYLE1iGKqM0bx+7BmVhrtcZA6WPGFvmKpOTFjmLH6NuEiDuxJTy63NVICFGIE4Fs5tEZosHEAKVQM35oHGjhtdTKWUW8QlvLtjGl9WSR8ZLzsRNRuY6J48K7K3AjSRx7WyoZY6pSJh/poGuqJ8FqO6J0hDCTEumIY8fGYA4n8Of0doJrj4gx0lCDMNjT8/mi5bzBBNDQDJcqMq7SgCLXqN033YnORRbeojgLJXpHi6KHUahYx963pu9yyt8BuQY/OEfkCncePWEXOVUtXs0fnKmCB6YqtLFIyR2Ug+CzhjPin9LE0eZSR7LlTowSCbzvPEySVTJayiOV1A/WOpjefK/CoPDRgc6ljtfejSve1xbAFT/sx7heCwCws+TCA2gjC2wZcOY7jhRxhIEaYmXT8OvIrbMiwcCTLp09rQ6+8T8pTgarOibsC5My+NebcWdmZ5CkPjgknog74KXQkhGfGV0wm1aUwj88B701AYURSSTtNYa51hQ68HxEoOeOpw1ylC51lLLmE/p08d/3Ij7mdIWHvi8P0dNPHstZaIJVUtBOLJuBj1llSlJRNQCGYyfnQGkohnnDjPPgsU2PvlZocX2BUWqAQ02ns3qpf/qotqe3GjeySAx5xYQXdMxFkzjYK5eyge+X7YKCQYwgMPDlKCYyLuwIIq63PMkV3bW/vqxn4gZ9BtyG8LyBS9vIF6ROzAy24VPPr7T3PmQVBSvlEROywFF2YDGvTvJPotwzGMjHNxktaj8j8HbQrF/R2TlXKeh4X1SncYQcPSH93fO9P+OZIR5jAJn+zLNEd2DdNX/57Eo78XYVL4AVFvvHTkd1qWhklmd8cDCmu9HPwVKsbuDAqsxasHb1bRwVgg+z9OxclSPxPx3r27HX+3bnJ7uhm9aTRY0Pz7b2jxN9e+7fCxeThNxglR/fvnPLKDFz8x5ioQgffUZdUnW7Z21f0hmeg6EIwOhGPQ5CNaqHq3AGgHi8ANzPJMILRRWEm8Wv/963JT2I+Npi4xUKpk8KJPbuB3176yQdwzqAZr0ivhZxLcqlA0gpd49jOWviYx2YoAzBtmCKIriDlW5d4KmradyCY3WQRmBiG4BmB9OF5cpZIUpz5lzf/qlbv1kGKw3NLoS5XtpP+aqdZBud2BXuKN6xBVe4zLUmMaLrIGDNSUW1MytHRV0hSQcH1pNDVc1V8Tx2yjHRt1dOXbt6U992XdPadn0ns3E9R/OMDq91H57t2zunWnvn/b69+lbf3jxpswlYeZFydFiFEmaub4hIZIxfeIlrfaklGucwJygjKhqJ2FGwkVhxTJitQTAUqqK9v664bdes7d4eCQ3mE4JY65TsBiV9tb6HIc7de1s7rW179LWFr8m3lTiuA5fwQOvktU96HipZEmN4t3Jp8DMohYxlPCaQuDqYSCgr5yAynLMpokIUwkMT9CZdW1+6NRILwepzaht0oJQ84ifq+ARxx02zdsdNrR1XR58+uqLXP8TRKXKJy6d6k92Sq+ITFX0P4aoe8K1aJKe5sIPArrh1aUR3I0knGBHbzdd3To5P4tOxKikEFGMthSkv6V3aAd/YPm/PvrJof3wRqyosVOIStxKb4hluWi4IpnwexDEAss2kVIokOSat60AL5Di946aufX6v/3aDB48hiSRcn4FZWhefMeGrx2v1J9gn/6JXHLApZrgK2l686+ByJJ/kdFMCNxbxqqbukRRJ0tAQYpC0lXMtV/t2ce3M7FaiQU8kXscxpUeuqanIPsSd8lCim1/97CwwOYHQARc4/UCXnl8A2IH4IDnm1PebTGQv5jRJJx3K5QzH113V2hdvmXQObzWmdPFynoqKZi76PPVheeuOmS4DFb7wCAR4wMwgoRF/+IsOSk+K+apG97IqEEl7HtodLr+ybxauCcJxGeOyTMq35rs/NWt7b6gdFTM7js6h5t3HrDXJBw9g+lYNRh3OLRUq4czXlbpNX7NfNfmCCRcXGgSq40J6g2yibFKnYn1ZhZ1p4yzrERE443IakkJXgpBBR16xRfGiYWc6+eU613Fthux23VguNuwjbS+ma3nGLt3CUOuat17ZtVtuzG0pJtvPyaAgo+hmdLc+K+LLCfKSYIVsOa31WvyqyI36vnLLho8miJPpQbyLjjKQokmdBrAXML59t25s0p1uQ7oWO5A5kjZ+aOUzfJoov/5rkvIgFT4yQeF0l75xng6AXdbAIF0Uid/LGbwl8dU+f3ZjkJDfeOU3noviiY9f3nSQ598mInO3HQWVpKqBMvwb9CEWPHWIvPhAmaHZdszJyynkl3jm/eL6reHDfvx8DHz4AzPDXRVmluq5/vdLdXBC2a14hox3K8zW2p72Nj2F/8wmBAQp9lT1cmjs69i2aTUutqef35lQxKMZOrrZqdlKvzhhZlVDi7iAq4vsqwv85ajQ51wJFaDLSWSqW/blvjLkT+HRKe4TdEmHCxBJwatD/9R0gu9Fj0nn06GGJooy8WxLO/nZr9j44vN6RNnIW5PJfGUiOfMRQeeYqNum1ODXALSvJzEGW8XgZoeRrykZxMcju4E7KJMUw3JLhLPvjmmLzo64ItlB1AjgLSujqFBuYfjw5JjA+EQ/eGGHLXcvZKWDknWYkefsGLmmoF7jTwo+iCU64jGnH8XnI1PF5bFGZR0bf45v2yOzrp8dUpLSgTE6sPJglDK5YZRj3IYePNGTNXyGfYoGpHVFVyyDGnSIEYWzrvSnoKsw02RDHn4L0/gM71ZWrlg6NHvwPv6ZdPF4AJGyHKMc3zVSyQBvZ1Rmmgi0AZNK0LWm8galEzz9pi4LuoUvuqBZCnWbt5752Fd8uKNNJR7yqf9MlhB9e/yRg91xvzUvrV96SImdjIA4S0BUXfQAQjQvBTL24SKgoMOAPWfAYcsDTLxpYWTCCD+SEUeLis865GMXqwgOpxO2FXOkoyC6lk/23dJD+HCCDx7gv/K6g6oMNk7IgBzU+MPZpGNWlO7gPGV0gm0SgACBx0iSBGqHxE6IiqPiJKU56oZt2GQc7KVbvn0j9Fpm+NAhnsSzg49+J/771wni9of3zw8vuv6BfhFJWhcjyZxM0gYDLQJ+BZzSsd1qS6U9SQ5FiPfdAu/OyVFcg5FEbUPiR8zqasUcEw0MKHZ6EVs88Oj35oe18girWmn+wc+X79Vj4AlpbyGJeOVBgVBZcdd7QvNa5Cpoc8ijaQhAs908e8rbfPiyV9DZr2arym9YuYA8OliHrqegzYg1UsU5Oe/UuUlySIcOhmprP/7W/PDSbL5PRo/pTWC4u1JdsNhZ0sP28/WFPK4jbzclzFxdchIASR/YhoxOhy4y+/SM8tiloftim1ZM7xr/U3r32Hy+tO/85MhJNfv48aMn9L+k7dyBldbtl9e9XTfbubJY+F+/4sGLrVBw1gQVjYtk3U0x3QUngSJK6BNaiZVdiliHBB0xGWKQFHyNUyJPzLp2TJwj89nSoUe+y5Ng7fF/n5mDzzLMzb0AAAAASUVORK5CYII=);
      background-position: center;
      background-size: 100% 100%;
      width: 1.8rem;
      height: 1.8rem;
      display: block;
      min-width: 1.8rem;
      margin-left: 10px;
    }

    .aiItems {
      clear: both;

      .aiItem {
        width: 100%;
        margin: 10px 0;
        display: flex;
      }

      .rightMessage,
      .leftMessage {
        display: flex;
        width: 100%;
        // width: calc(100% - 2.4rem);

        .messageContent {
          max-width: max-content;
          word-break: break-all;
          // white-space: pre-wrap;
          flex-grow: 1;
          line-height: 24px;
          box-shadow: rgba(7, 12, 20, 0.12) 0 2px 8px 0;
          border-radius: 6px;
          box-sizing: border-box;
          padding: 8px;
          background-color: #fff;
          color: #444;

          .messageContentInfo {
            border-top: 1px dashed #f2f2f2;
            display: flex;
            justify-content: space-between;
            align-content: center;
            .tips {
              font-size: 12px;
              color: #aaa;
            }

            .aiTools {
              .toolAIIcon {
                font-size: 1rem;
                color: #666;
                margin: 2px;
                cursor: pointer;
              }

              .toolAIIcon:not(.effic):hover {
                color: #333;
              }

              .toolAIIcon.active {
                color: #ff9900;
              }

              .toolAIIcon.effic {
                cursor: not-allowed !important;
              }
            }
          }
        }
      }

      .rightMessage::after,
      .rightMessage::after {
        content: '';
      }

      .rightMessage {
        justify-content: flex-end;
        padding-left: 2.4rem;

        clear: both;

        .messageContent {
          background-color: #d9e5fc;
        }
      }

      .leftMessage {
        text-align: left;
        // float: left;
        clear: both;
        padding-right: 2.4rem;
      }
    }
  }

  .sendContainer {
    display: flex;
    box-sizing: border-box;
    padding: 0 0.8rem 1rem 0.8rem;
    flex-direction: column;

    .baseBtn {
      max-width: max-content;
      margin-right: 1rem;
      display: flex;

      .changeBtn {
        margin-bottom: 10px;
        font-size: 12px;
        color: #666;
        margin-right: 10px;
      }
    }

    .inputContainer {
      width: 100%;
      flex-grow: 1;

      padding: 0.2rem 3rem 0.2rem 0.2rem;
      background-color: #fff;
      border: 1px solid #2468f2;
      box-shadow: 0 4px 8px 0 rgba(36, 104, 242, 0.1);
      border-radius: 6px;
    }

    .sendBtn {
      width: 2.4rem;
      height: 1.6rem;
      background-image: url(data:image/png;base64,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);
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      bottom: 1.2rem;
      right: 1rem;
      background-color: transparent;
      border: none;
    }

    .sendBtn.active {
      background-image: url(data:image/png;base64,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);
    }
  }
}
</style>
<style lang="less">
.intelligentAssistanceContainer {
  textarea.ivu-input {
    border: none !important;
  }
}
</style>